import meal_travel_reimbursement from "../../shared/meal_travel_reimbursement";

export default {
  name: "Additional Material Terms and Conditions of the Job Offer",
  prefix: "E",
  sections: [
    {
      divider: "hide",
      name: "Provision of Meals",
      fields: [
        {
          code: "E.1a",
          machine_name: "isMealProvision",
          widget: "text",
          validate: [
            {
              fieldArrayContainsValue: "Provision of Meals",
              needsFieldValues: true,
              message: "An Addendum C is required for E.1a Provision of Meals.",
              extraData: {
                fieldArray: "eta_790a_addendum_c",
                fieldToCheck: "section_number",
              },
            },
          ],
          // Data cleaned to set YES when Addendum C is attached
          disabled: true,
          inputHidden: true,
          label: `Description of how the employer will provide each worker who resides in employer provided or secured housing with three meals per day or furnish free and convenient cooking and kitchen facilities for workers to prepare their own meals.`,
          tooltip: `On Addendum C, describe <u>how</u> the employer will provide each worker with three (3) meals a day or furnish free and convenient cooking and kitchen facilities so that workers can prepare their own meals.  Where the employer provides facilities for workers to prepare their own meals, please explain how the workers will have access to stores where they can purchase groceries and describe the facilities and space for food preparation, as well as the necessary equipment, appliances (including refrigeration), cooking accessories, and dishwashing facilities (<em>e.g.</em>, adequate sinks with hot and cold water under pressure) that are in working condition and will be used by workers to sufficiently prepare three (3) meals a day.  If the employer has an agreement with a third-party that will prepare the meals for the employer's workers, identify the vendor and explain the employer's arrangement with the vendor with sufficient detail to apprise workers how, when, and where the workers will obtain the meals from the vendor and that the employer will pay the vendor directly for the meals provided.
          <br>
          <br>
          <strong>Important Note:  Only one (1) Addendum C may be used to fully disclose the provision of meals and DO NOT repeat the MEALS guarantee language under Section G, which will result in the SWA or CO issuing a NOD to request removal of such duplicative language.</strong>  Providing access to third-party vendors and requiring workers to purchase meals from the third-party vendor does not constitute compliance with the requirement to provide meals or cooking and kitchen facilities, even if the employer provides a meal stipend.  Employers who provide facilities for workers to prepare their own meals should consider disclosing to workers how meals will be provided, including any appropriate meal charges, in the event kitchen facilities become temporarily inoperable or otherwise unavailable.`,
          placeholder: "NO",
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_meal_provision",
      divider: "hide",
      coloring: "blue",
      isModal: true,
      master_fieldArray: "eta_790a_addendum_c",
      maxAllowed: 1,
      listType: "inline",
      sectionHeader: "Material Terms and Conditions - Provision of Meals",
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          disabled: true,
          initialValue: "Provision of Meals",
          validate: ["required"],
          tooltip: "Provision of Meals.",
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          disabled: true,
          initialValue: "Provision of Meals",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
          // tooltip: "tooltip"
        },
      ],
    },
    {
      name: "",
      fields: [
        {
          isGroup: {
            code: "E.1b",
            label: "The employer:",
            machine_name: "eta_790a_e2b_will_charge",
            tooltip: `Select the option designating whether the employer will or will not charge workers for the provision of meals. If the employer will provide free and convenient cooking and kitchen facilities or will provide meals at no charge, mark the “will not charge” box. If the employer will provide meals, or will provide free and convenient cooking and kitchen facilities but wishes to disclose a meal charge, for example, in the event the kitchen facilities become unavailable, and intends to charge workers for the provision of meals, the daily charge per worker must be entered in currency format (<em>e.g.</em>, $14.00).`,
            coloring: "none",
            disabled: true,
            required: true,
            Other_machine_name: "eta_790a_e2a_will_not_charge",
            validate: ["required"],
            fields: [
              {
                widget: "radio",
                choice: "<b>WILL NOT</b> charge workers for meals.",
                value: "NO",
                validate: ["required"],
                clearSchema: ["eta_790a_e2c_meal_charge"],
              },
              {
                widget: "radio",
                choice:
                  "<b>WILL</b> charge each worker for meals at $____.__ per day, if meals are provided.",
                value: "YES",
                validate: ["required"],
              },
            ],
          },
        },
        {
          machine_name: "eta_790a_e2c_meal_charge",
          widget: "wage",
          label: "Meal Charge",
          maxLength: 4,
          validate: [
            "required",
            {
              minValue: 0.01,
              message:
                "The amount of the charge per day if meals are provided, must be greater than $0.00",
            },
          ],
          isVisible: {
            when: "eta_790a_e2b_will_charge",
            is: "YES",
          },
          warning: {
            text: "The charge amount entered appears to exceed than the current standard meal charge per day per worker. In accordance with 20 CFR 655.173, the employer may file a petition with the OFLC Certifying Officer to charge more than the standard amount for meal charges. Please be prepared to submit, at the time of filing your H-2A application, documentation justifying the meal charge. Documentation submitted must include the cost of goods and services directly related to the preparation and serving of meals, the number of workers fed, the number of meals served and the number of days meals were provided. The cost of the following items may be included: Food; kitchen supplies other than food, such as lunch bags and soap; labor costs that have a direct relation to food service operations, such as wages of cooks and dining hall supervisors; fuel, water, electricity, and other utilities used for the food service operation; and other costs directly related to the food service operation. Charges for transportation, depreciation, overhead and similar charges may not be included. Receipts and other cost records for a representative pay period must be retained and must be available for inspection by the CO for a period of 1 year.",
            isVisible: {
              when: "eta_790a_e2c_meal_charge",
              is: "56",
              operator: ">=",
            },
          },
        },
      ],
    },
    {
      divider: "hide",
      name: "Daily Transportation",
      fields: [
        {
          code: "E.2",
          machine_name: "isDailyTransport",
          widget: "text",
          // Data cleaned to set YES when Addendum C is attached
          disabled: true,
          inputHidden: true,
          validate: [
            {
              fieldArrayContainsValue: "Daily Transportation",
              needsFieldValues: true,
              message:
                "An Addendum C is required for E.2 Daily Transportation.",
              extraData: {
                fieldArray: "eta_790a_addendum_c",
                fieldToCheck: "section_number",
              },
            },
          ],
          label: `Description of how the employer will provide transportation to each worker who resides in employer provided or secured housing, at no cost to workers, from the location of such housing and, if applicable, centralized pick-up points to the places of employment at the beginning and end of each workday. If the daily transportation at no cost to workers is available to workers who do not reside in employer-provided housing, specify the transportation benefit to the worker(s).`,
          tooltip: `On Addendum C, describe how the employer will provide workers daily transportation to the place(s) of employment.  At a minimum, describe the arrangements for transporting workers, at no cost to workers, from employer-provided or secured housing and, if applicable, centralized pick-up points to the places of employment at the beginning of each workday and back at the end of each workday.  Describe the employer’s daily transportation plan with sufficient detail to apprise workers of the mode(s) of transportation (<em>e.g.</em>, vans, buses) that will be used each day as well as the daily transportation schedule.  Identify the number of vehicles to be used and type of vehicle and seating capacity for each vehicle.  State whether the vehicles to be used will be provided by the fixed-site grower(s), are authorized for use under a valid Farm Labor Contractor Certificate of Registration, or belong to a common carrier, identifying the common carrier by name.  In addition, identify whether the daily transportation at no cost to workers is available to workers who do not reside in employer-provided housing.  Similarly, describe any other transportation the employer will provide (<em>e.g.</em>, for personal errands).
          <strong>Only one (1) Addendum C may be used to fully disclose the provision of daily transportation and DO NOT repeat the DAILY TRANSPORTATION guarantee language under Section G, which will result in the SWA or CO issuing a NOD to request removal of such duplicative language.</strong>`,
          placeholder: "NO",
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_daily_transportation",
      coloring: "blue",
      isModal: true,
      master_fieldArray: "eta_790a_addendum_c",
      maxAllowed: 1,
      listType: "inline",
      sectionHeader: "Material Terms and Conditions - Daily Transportation",
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          disabled: true,
          initialValue: "Daily Transportation",
          validate: ["required"],
          tooltip:
            "Category should be Materials Terms and Conditions - Daily Transportation.",
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          disabled: true,
          initialValue: "Daily Transportation",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
          // tooltip: "tooltip"
        },
      ],
    },
    {
      divider: "hide",
      name: "Inbound/Outbound Transportation",
      fields: [
        {
          code: "E.3a",
          machine_name: "isEmploymentTransport",
          widget: "text",
          // Data cleaned to set YES when Addendum C is attached
          disabled: true,
          inputHidden: true,
          validate: [
            {
              fieldArrayContainsValue: "Inbound/Outbound Transportation",
              needsFieldValues: true,
              message:
                "An Addendum C is required for E.3a Inbound/Outbound Transportation.",
              extraData: {
                fieldArray: "eta_790a_addendum_c",
                fieldToCheck: "section_number",
              },
            },
          ],
          label: `Description of how the employer will provide workers with transportation (a) to the place of employment from the place from which the worker has come to work for the employer (<em>i.e.</em>, inbound) and (b) from the place of employment to the place from which the worker departed (<em>i.e.</em>, outbound). State whether such transportation, and related daily subsistence, will be provided by the employer or how the employer will make payment to the worker for reasonable costs incurred (<em>e.g.</em>, by advance payment or reimbursement).`,
          tooltip: `On Addendum C, describe how the employer will provide workers with transportation (a) to the place of employment from the place from which the worker has come to work for the employer (i.e., inbound) and (b) from the place of employment to the place from which the worker departed (i.e., outbound).  At a minimum, state whether such transportation, and related daily subsistence, will be provided by the employer or paid by the employer to the worker for reasonable costs incurred (<em>e.g.</em>, advance payment or reimbursement) and identify the modes of transportation, if known.  For example, the employer may state that it will provide or pay for charter bus services or other modes of transportation to groups of workers, or permit workers to select any means of transportation they choose and reimburse workers at no less than the most economical and reasonable common carrier transportation charges for the distances involved.  
          <strong>Only one (1) Addendum C may be used to fully disclose the provision of inbound/outbound transportation and DO NOT repeat the INBOUND/OUTBOUND TRANSPORTATION guarantee language under Section G, which will result in the SWA or CO issuing a NOD to request removal of such language.</strong>`,
          placeholder: "NO",
        },
      ],
    },
    {
      divider: "hide",
      machine_name: "_add_addendum_c_inbound_outbount_transportation",
      coloring: "blue",
      isModal: true,
      master_fieldArray: "eta_790a_addendum_c",
      maxAllowed: 1,
      listType: "inline",
      sectionHeader:
        "Materials Terms and Conditions - Inbound/Outbound Transportation",
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          disabled: true,
          initialValue: "Inbound/Outbound Transportation",
          validate: ["required"],
          tooltip:
            "Category should be Materials Terms and Conditions - Inbound/Outbound Transportation.",
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          disabled: true,
          initialValue: "Inbound/Outbound Transportation",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
          // tooltip: "tooltip"
        },
      ],
    },
    {
      fields: [
        {
          isGroup: {
            code: "E.3b",
            fieldLevelErrors: true,
            machine_name: "_meal_reimbursement",
            tooltip:
              "Enter the amounts per day that the employer will pay for or reimburse daily subsistence for each worker during the travel described in 3a.",
            label: `During the travel described in Item 3a, the employer will pay for or reimburse daily meals by providing each worker`,
            fields: [
              {
                code: "a",
                machine_name: "eta_790a_f3a_no_less_than",
                widget: "wage",
                label: "no less than",
                labelPostfix: "per day",
                validate: [
                  "required",
                  {
                    minValue: meal_travel_reimbursement.TravelMin,
                    message:
                      "Employer will pay/reimburse daily meals no less than value must be greater than current OFLC Public Amount.",
                  },
                  {
                    maxValue: meal_travel_reimbursement.TravelMax,
                    message:
                      "Employer will pay/reimburse daily meals no less than value must be less than current OFLC Public Amount.",
                  },
                ],
                maxLength: 4, // accounts for the "$" and decimals
                tooltip:
                  "Enter the minimum daily subsistence amount per day in currency format (<em>e.g.</em>, $14.00).",
              },
              {
                code: "b",
                machine_name: "eta_790a_f3b_no_more_than",
                widget: "wage",
                label: "no more than",
                labelPostfix: "per day with receipts",
                validate: [
                  "required",
                  {
                    minValue: meal_travel_reimbursement.TravelMin,
                    message:
                      "Employer will pay/reimburse daily meals no more than value must be greater than current OFLC Public Amount.",
                  },
                  {
                    maxValue: meal_travel_reimbursement.TravelMax,
                    message:
                      "Employer will pay/reimburse daily meals no more than value must be less than current OFLC Public Amount.",
                  },
                  {
                    fieldComparison: "eta_790a_f3b_no_more_than",
                    message:
                      'Employer daily meal reimbursement "no more than" value must be greater than or equal to "no less than" value',
                    needsFieldValues: true,
                    extraData: {
                      operator: ">=",
                      valueOf: "eta_790a_f3a_no_less_than",
                    },
                  },
                ],
                maxLength: 4, // accounts for the "$" and decimals
                tooltip:
                  "Enter the maximum daily subsistence amount per day with receipts in currency format (<em>e.g.</em>, $99.99).",
                info: {
                  text: `Employer daily meal reimbursement must be no less than $${meal_travel_reimbursement.TravelMin} and no more than $${meal_travel_reimbursement.TravelMax}.00.`,
                  coloring: "grey",
                  divider: false,
                  css: {
                    marginTop: 20,
                    marginBottom: 10,
                  },
                },
              },
            ],
          },
        },
      ],
    },
    {
      divider: "hide",
      name: "Deductions from Pay",
      fields: [
        {
          isGroup: {
            code: "E.4",
            machine_name: "isPayDeductions",
            widget: "radio",
            label: `Description of all deduction(s) from the worker’s paycheck the employer is required to make by law and all other deductions not required by law the employer will make from the worker’s paycheck, and, if known, the amount(s) for each deduction.`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: [
                  {
                    fieldArrayContainsValue: "Deductions from Pay",
                    needsFieldValues: true,
                    message: `An Addendum C is required for Deductions from Pay because you've selected "Yes".`,
                    extraData: {
                      fieldArray: "eta_790a_addendum_c",
                      fieldToCheck: "section_number",
                      onlyIf: "YES",
                      operator: "===",
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: [
                  "required",
                  {
                    fieldArrayContainsValue: "Deductions from Pay",
                    needsFieldValues: true,
                    message: `An Addendum C entry is only allowed if Deductions from Pay is selected as "Yes". Please either remove the Addendum C entry or indicate “Yes” in E.4 Deductions from Pay.`,
                    extraData: {
                      fieldArray: "eta_790a_addendum_c",
                      fieldToCheck: "section_number",
                      onlyIf: "NO",
                      operator: "===",
                      shouldContainValue: false,
                    },
                  },
                ],
              },
            ],
            tooltip: `If the employer will make any deductions from workers’ paychecks, check the box in Item E.4 to indicate that the description of deductions is available in Addendum C.  On Addendum C, describe all deductions from a worker’s paycheck that the employer is required by law to make and deductions not required by law to make.  For each deduction, provide the amount(s) of deduction, if known.   
            <br>
            <br>
            If no deductions will be made from any worker’s paycheck, DO NOT mark the checkbox. <strong>Only one (1) Addendum C may be used to fully disclose all deductions from pay and DO NOT repeat the DEDUCTIONS FROM WORKER’S PAY guarantee language under Section G, which will result in the SWA or CO issuing a NOD to request removal of such language</strong>.
            `,
          },
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_pay_deductions",
      coloring: "blue",
      isModal: true,
      sectionHeader: "Material Terms and Conditions - Deductions from Pay",
      openModalHeader: "Add Addendum C",
      master_fieldArray: "eta_790a_addendum_c",
      maxAllowed: 1,
      listType: "inline",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          disabled: true,
          initialValue: "Deductions from Pay",
          validate: ["required"],
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          disabled: true,
          initialValue: "Deductions from Pay",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
        },
      ],
    },
    {
      divider: "hide",
      name: "Other Material Terms and Conditions",
      fields: [
        {
          code: "E.5",
          machine_name: "eta_790a_h1_is_addendum_c_completed",
          widget: "text",
          disabled: true,
          inputHidden: true,
          label: `Description(s) of any other material terms, conditions, 
          and benefits (monetary and non-monetary) that will be provided by the employer under this job offer.`,
          tooltip: `If there are other material terms and conditions not already disclosed in other items of the job order, check the box in Item E.5 to indicate that the additional description of material terms and conditions is available in Addendum C.  On Addendum C, describe any other material terms, conditions, and benefits (monetary and non-monetary) that will be provided by the employer under this job opportunity that should be disclosed to prospective applicants in recruitment.  Additional material terms and conditions of employment must comply with the requirements of the Immigration and Nationality Act and the Department's applicable regulations.
          <br>
          <br>
          If all material terms and conditions under this job offer have been disclosed in other items of the job order, DO NOT mark the checkbox.  
            `,
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_other_material_terms",
      coloring: "blue",
      isModal: true,
      sectionHeader: "Material Terms and Conditions - Other",
      openModalHeader: "Add Addendum C",
      master_fieldArray: "eta_790a_addendum_c",
      listType: "inline",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          disabled: true,
          initialValue: "Other Material Terms and Conditions",
          validate: ["required"],
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
        },
      ],
    },
  ],
};
